import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import ProfileForm from "../components/ProfileForm/ProfileForm";
import style from "../components/ProfileForm/ProfileForm.module.css";
import Alert from "../components/Alert/Alert.jsx";
import { useTranslation } from 'react-i18next';
import { getProfile, updateProfile } from "../api/profile";
import { useAuth } from "../providers/AuthContext";

const Profile = () => {
  const { t } = useTranslation();
  const { updateUserName } = useAuth();
  const [alert, setAlert] = useState({ show: false, text: "", type: "" });
  const [initialUser, setInitialUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();
        setInitialUser({
          full_name: data.user.full_name,
          email: data.user.email,
          profileImage: null,
        });
      } catch (err) {
        console.error(err);
        setAlert({ show: true, text: t('profile.load_error'), type: "error" });
      }
    };

    fetchProfile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveChanges = async (updatedUser) => {
    try {
      await updateProfile(updatedUser.full_name, updatedUser.email);
      updateUserName(updatedUser.full_name);
      setAlert({ show: true, text: t('profile.success'), type: "success" });
      setInitialUser(updatedUser);
    } catch (err) {
      console.error(err);
      setAlert({ show: true, text: t('profile.error'), type: "error" });
    }
  };

  const handleResetChanges = () => {
    setAlert({ show: true, text: t('profile.cancelled'), type: "info" });
  };

  return (
    <div className={style.container}>
      {alert.show && (
        <Alert
          text={alert.text}
          type={alert.type}
          onClose={() => setAlert({ show: false, text: "", type: "" })}
        />
      )}
      <Link className={`${style.goBackButton} thirdly-button`} to="/dashboard">← {t('profile.title')}</Link>
      <h2 className="page-title">{t('profile.settings')}</h2>
      {initialUser && (
        <ProfileForm
          onSave={handleSaveChanges}
          onReset={handleResetChanges}
          initialUser={initialUser}
        />
      )}
    </div>
  );
};

export default Profile;